module.exports = __webpack_public_path__ + "static/media/apple-logo.3def51a8.png";